var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnsweredMarked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 9,
    viewBox: "0 0 9 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 4.67263,
    cy: 4.67458,
    r: 3.82692,
    fill: "url(#paint0_linear_25034_15104)",
    stroke: "url(#paint1_linear_25034_15104)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_25034_15104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.44096 2.55859H3.51788C3.39037 2.55859 3.26809 2.60925 3.17792 2.69941C3.08776 2.78957 3.03711 2.91186 3.03711 3.03936V6.88552C3.03711 7.01302 3.08776 7.13531 3.17792 7.22547C3.26809 7.31563 3.39037 7.36629 3.51788 7.36629H6.40249C6.53 7.36629 6.65229 7.31563 6.74245 7.22547C6.83261 7.13531 6.88326 7.01302 6.88326 6.88552V4.0009L5.44096 2.55859Z",
    stroke: "#FDFEFB",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.44141 2.55859V4.0009H6.88371",
    stroke: "#FDFEFB",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.92308 5.20312H4",
    stroke: "#FDFEFB",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.92308 6.16406H4",
    stroke: "#FDFEFB",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.48077 4.24219H4.24038H4",
    stroke: "#FDFEFB",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_25034_15104",
    x1: 4.67263,
    y1: 0.347656,
    x2: 4.67263,
    y2: 9.0015,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADDC31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4BA619"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_25034_15104",
    x1: 4.67263,
    y1: 0.347656,
    x2: 4.67263,
    y2: 9.0015,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADDC31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4BA619"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_25034_15104"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 5.76923,
    height: 5.76923,
    fill: "white",
    transform: "translate(2.07617 2.07812)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnsweredMarked);
export default __webpack_public_path__ + "static/media/answered_marked.1d5de5da4fc0c7d5e30199f47595a307.svg";
export { ForwardRef as ReactComponent };